import { render } from "./list.vue?vue&type=template&id=3f055fc8&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=3f055fc8&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f055fc8"]])

export default __exports__